
import React from 'react'
import PropTypes from 'prop-types'

const ToolsNavigation = () => (
  <div>
    These are the tools 🔨 I use to make things.
    <br/>
    <br/>
    <p>“To become a master at any skill, it takes the total effort of your: heart, mind, and soul working together in tandem.” </p>
    <p>― Maurice Young</p>
  </div>
);

export default ToolsNavigation;